
/**
 * Classe utilitária responsável pela manipulação de datas nos projetos Agro.
 */
export class DateUtil {

    static removeTimezone(value: string) {
        return value.substring(0, value.lastIndexOf('-'));
    }

    static toE8601DZw(value: string, removeTimezone?: boolean | false) {
        //Para a versão 4 do THF
        //Independentemente do formato utilizado, o componente trata o valor do model internamente com o formato Data (E8601DAw.): yyyy-mm-dd.

        let date = new Date((removeTimezone ? DateUtil.removeTimezone(value) : value));

        return this.E8601DZw(date);
    }

    private static E8601DZw(date: Date) {
        var format = date.getUTCFullYear() +
            '-' + this.pad(date.getMonth() + 1) +
            '-' + this.pad(date.getDate()) +
            'T' + this.pad(date.getHours()) +
            ':' + this.pad(date.getMinutes()) +
            ':' + this.pad(date.getSeconds()) +
            this.getOffset(date.getTimezoneOffset());

        return format;
    }

    private static pad(value) {
        if (value < 10) {
            return '0' + value;
        }

        return value;
    }

    private static getOffset(timezoneOffset) {
        var minutes;
        var symbol;

        if (timezoneOffset < 0) {
            minutes = 0 - timezoneOffset;
            symbol = "+";
        } else {
            minutes = timezoneOffset;
            symbol = "-";
        }

        var hours = this.pad(Math.floor(minutes / 60));

        var minutes = this.pad(minutes % 60);

        return symbol + hours + ":" + minutes;
    }

}